import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { offices, providers, reports, searchID, sites } from "@signals"
import { analyzerFilters, isAnalyzerLoading, resetSignals, responseData } from "Pages/AnalyzersV2/@signals"
import { array, number, object } from "yup"
import { useValidatorSeeker } from "@app"
import { ratingPayload } from "Pages/AnalyzersV2/Rating/@signals"


export default function useAnalyzerRatingFilters() {
	const { showToast } = useToast()
	const schema = object({
		...!searchID.value && { officePickupID: number().required('Offices is required') },
	})
	const {
		isValid,
		errors
	} = useValidatorSeeker({ officePickupID: offices.value, providerID: providers.value }, schema)

	const onSubmit = useCallback((clearTab = false) => batch(() => {
		isAnalyzerLoading.value = true
		responseData.value = {}
		return postSubmit("/api/dashboard/results", ratingPayload.value).then(res => {
			resetSignals(clearTab)
			batch(() => {
				responseData.value = res
				analyzerFilters.value = res.filters
				isAnalyzerLoading.value = false
			})
		}).catch(() => {
			showToast.error()
			isAnalyzerLoading.value = false
		})
	}), [providers.value, offices.value, sites.value, reports.value, searchID.value])

	return {
		onSubmit: onSubmit,
		isValid: isValid,
		errors: errors,
		schema: schema
	}
}